import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PARAMETERS_INIT_FAIL, UOM_INIT_LOADING, UOM_INIT_SUCCESS, UOM_INIT_FAIL } from '@/store/types'
export const uom = {
  async uomInit({ commit, state }) {
    const apiUrl = state.menu.uom
    if (apiUrl) {
      commit(UOM_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(UOM_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(UOM_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PARAMETERS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  }
}
